import { axios } from 'utils/axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { queryClient } from 'utils/react-query';
import { useNovaToast } from 'hooks/utils/useNovaToast';
import { ToastVariant } from 'types/Toast';
import { ReadIds } from './useReadIds';

export const unmarkAsRead = async (articleId: string): Promise<void> => {
  await axios.delete(`read-state/${articleId}`);
};

export const useUnmarkAsRead = (): UseMutationResult<void, unknown, string, unknown> => {
  const { show } = useNovaToast();

  return useMutation({
    mutationFn: unmarkAsRead,
    onError: () => {
      show({ variant: ToastVariant.ERROR });
    },
    // See markAsRead.ts — same direct cache patch instead of invalidating.
    onSuccess: (_data, articleId) => {
      queryClient.setQueryData<ReadIds>(['read-state'], (current) => {
        if (!current) return current;
        return { readIds: current.readIds.filter((id) => id !== articleId) };
      });
      show({
        title: 'Als ungelernt markiert',
        description: 'Der Artikel wartet wieder darauf, gelernt zu werden.',
        variant: ToastVariant.SUCCESS,
      });
    },
  });
};
